import { Link, useLocation } from "react-router-dom";
import { Compass } from "lucide-react";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const navItem = (to, label, testid) => (
    <Link
      to={to}
      data-testid={testid}
      className={`text-sm tracking-wide transition-colors hover:text-[var(--kk-bluegreen)] ${
        pathname === to ? "text-[var(--kk-anthracite)]" : "text-[var(--kk-anthracite)]/60"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <div className="min-h-screen flex flex-col bg-[var(--kk-offwhite)]">
      <header className="border-b border-[hsl(var(--border))] bg-white/70 backdrop-blur-sm sticky top-0 z-30">
        <div className="kk-container flex items-center justify-between py-5">
          <Link to="/" className="flex items-center gap-3 group" data-testid="brand-home-link">
            <span className="relative inline-flex w-8 h-8 items-center justify-center border border-[var(--kk-anthracite)]">
              <Compass className="w-4 h-4 text-[var(--kk-anthracite)] group-hover:rotate-45 transition-transform duration-700" strokeWidth={1.5} />
            </span>
            <div className="leading-tight">
              <div className="text-[15px] font-semibold tracking-tight text-[var(--kk-anthracite)]" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>
                KI-Kompass
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--kk-bluegreen)]">
                Standortbestimmung
              </div>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            {navItem("/", "Start", "nav-home")}
            {navItem("/methode", "Methode", "nav-methode")}
            {navItem("/kompass", "Kompass starten", "nav-kompass")}
          </nav>
          <Link to="/kompass" className="kk-btn-primary text-xs" data-testid="header-cta-btn">
            Jetzt starten
          </Link>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-[hsl(var(--border))] bg-white kk-no-print">
        <div className="kk-container py-10 grid md:grid-cols-3 gap-8 text-sm">
          <div>
            <div className="kk-overline mb-3">KI-Kompass</div>
            <p className="text-[var(--kk-anthracite)]/70 leading-relaxed">
              Ihr digitaler Erstberater. Erkennt Zeitfresser, identifiziert
              Entlastungspotenziale und empfiehlt einen schlanken Pilot.
            </p>
          </div>
          <div>
            <div className="kk-overline mb-3">Für</div>
            <ul className="space-y-1.5 text-[var(--kk-anthracite)]/70">
              <li>Kommunen &amp; Verwaltung</li>
              <li>Stadtwerke &amp; Versorger</li>
              <li>Kläranlagen</li>
              <li>Handwerk &amp; Mittelstand</li>
            </ul>
          </div>
          <div>
            <div className="kk-overline mb-3">Hinweis</div>
            <p className="text-[var(--kk-anthracite)]/70 leading-relaxed">
              Der Kurzbericht wird automatisiert auf Grundlage Ihrer Angaben
              erstellt. Er dient als erste Standortbestimmung, bewertet keine
              Personen und ersetzt keine individuelle Beratung.
            </p>
          </div>
        </div>
        <div className="border-t border-[hsl(var(--border))]">
          <div className="kk-container py-5 text-xs text-[var(--kk-anthracite)]/55 flex flex-wrap justify-between items-center gap-x-6 gap-y-2">
            <span>© {new Date().getFullYear()} KI-Kompass</span>
            <nav className="flex flex-wrap items-center gap-x-5 gap-y-2" aria-label="Rechtliches">
              <a
                href="https://www.one-a-com.net/impressum"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[var(--kk-anthracite)] underline-offset-4 hover:underline"
                data-testid="footer-impressum-link"
              >
                Impressum
              </a>
              <a
                href="https://www.one-a-com.net/datenschutz"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[var(--kk-anthracite)] underline-offset-4 hover:underline"
                data-testid="footer-datenschutz-link"
              >
                Datenschutz
              </a>
              <span className="hidden sm:inline text-[var(--kk-anthracite)]/35">
                Eine Methode aus über zehn Jahren Beratungspraxis.
              </span>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  );
}
